export default {
  // 模式
  "common.mode.auto": "Samopoužitie generovanej energie",
  "common.mode.economy": "Hospodársky režim",
  "common.mode.exigency": "Požiarný režim",

  // 设备
  "common.grid": "Elektrická sieť",
  "common.evChargers": "Nabíjačky pre elektromobily",
  "common.evCharger": "Nabíjačka pre elektromobil",
  "common.pv": "Fotovoltaika",
  "common.inverter": "Prevodník",
  "common.pcs": "Prevodník + batéria",
  "common.terminal": "Terminálne zariadenie",
  "common.airc": "Klimatizácia",
  "common.engine": "Motor",
  "common.battery": "Batéria",
  "common.metter": "Merací čítač",
  "common.other": "Iné",
  "common.power": "Môc",
  "common.powerTotal": "Celková môc",
  "common.voltage": "Napätie",
  "common.electricity": "Elektrická energia",
  "common.current": "Prúd",
  "common.homeUsage": "Celková domáca záťaž",
  "common.battery.power": "Môc batérie",

  // 数据
  "common.noDataAvailable": "Zatiaľ žiadne údaje~",
  "common.tips": "Poznámka",
  "common.reset": "Resetovať",
  "common.currencyUnit": "¥",
  "common.submiting": "Odosielanie prebieha, prosím počkajte...",
  "common.close": "Zavrieť",
  "common.from": "Z",
  "common.useIn": "Pre",
  "common.energyPercent": "Podiel energového toku",
  "common.dataFlow": "Tok dát",
  "common.getDataIng": "Získavanie dát prebieha, prosím počkajte...",
  "common.pageLoading": "Obsah stránky sa načíta, prosím počkajte...",
  "common.reseting": "Resetovanie obsahu stránky, prosím počkajte...",
  "common.save": "Uložiť",
  "common.onlyNumberTips": "Môžete zadať iba čísla",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault": "Chyba",
  "common.charge": "Nabíjať",
  "common.discharge": "Vybíjať",
  "common.buy": "Kúpiť",
  "common.sell": "Predať",
  "common.loadingInfo": "Načítanie prebieha, prosím počkajte...",

  // 
  "common.moreFeatures": "Viac funkcií",
  "common.confirm": "Potvrdiť",
  "common.saveing": "Ukladanie prebieha, prosím počkajte...",
  "common.searchPlacholder": "Zadajte kľúčové slovo pre vyhľadávanie",
  "common.iSee": "Rozumiem",
  "common.pageErrorTips1": "Ach, stránka má chybu~",
  "common.pageErrorTips2": "Skúste obnoviť stránku alebo kontaktovať podporu~",
  "common.refresh": "Obnoviť",
  "common.backToHome": "Späť na domovskú stránku",
  "common.checkTips": "Kontrola prebieha, prosím počkajte...",
  "common.back": "Späť",
  "common.cancel": "Zrušiť",
  "common.optional": "Voliteľné",
  "common.required": "Povinné",
  "common.status": "Stav",
  "common.statusNoDelete": "Nezrušené",
  "common.statusDelete": "Zrušené",
  "common.submit": "Odoslať",
  "common.disable": "Zakázať",
  "common.enable": "Povoliť",
  "common.year": "rok",
  "common.month": "mesiac",
  "common.day": "deň",
  "common.version": "Verzia:",
  "common.backHome": " Späť na domovskú stránku",
  "common.backHomeSorry": " Prepáčte, stránka sa stratila",
  "common.requestTips1": "Spracovanie dát prebieha, neposielajte znovu",
  "common.requestTips2": "Systémová správa",
  "common.requestTips3": "Stav prihlásenia vypršal, prihláste sa znovu",
  "common.requestTips4": "Prihlásiť sa znovu",
  "common.requestTips5": "Neplatná relácia alebo relácia vypršala, prihláste sa znovu.",
  "common.requestTips6": "Chyba servera, prosím skúste to neskôr.",
  "common.requestTips7": "Vypršanie času požiadavky na systémové rozhranie",
  "common.requestTips8": "Systémové rozhranie",
  "common.requestTips9": "Chyba",
  "common.iknow": "Rozumiem",
  "common.logoutSuccess": "Odhlásenie úspešné",
  
  // 了解更多组件
  "common.knowMore.title": "Pre viac informácií kontaktujte Beineng",
  "common.knowMore.email": "Kontaktný e-mail",
  "common.knowMore.phone": "Kontaktné telefónne číslo",
  "common.knowMore.wechat": "Kontaktný WeChat",
  "common.knowMore.website": "Adresa oficiálneho webu",
  "common.knowMore.address": "Kontaktná adresa",
  "common.knowMore.addressDetail": "Miestnosť 1205, Miestnosť 1301, Budova 5, Úlica Qinghe 8, Huangjingkeng, obec Huangjiang, mesto Dongguan, provincia Guangdong",
  
  // 本地连接组件
  "common.localConnection": "Miestne pripojenie",
  "common.operateInApp": "Operujte v aplikácii!",
  
  "common.enbleStaus": "Stav zapnutia",
  "common.battery.status": "Bez nabíjania a vybíjania",

  "account.forgetThePassword": "Zabudnuté heslo",
  "account.logInDirectly": "Prihlásiť sa priamo",
  "account.tips1": "Prechod na stránku prebieha, prosím počkajte...",
  "account.tips2": "Najskôr prečítajte a súhlassíte s podmienkami používania!",
  "account.autoLogin": "Automatické prihlásenie",
  "account.userLogin": "Prihlásenie používateľa",
  "account.registerTips": "Nemáte účet? Kliknite sem pre registráciu",
  "account.userEmail": "Používateľské meno / e-mail",
  "account.userEmailTips": "Zadajte používateľské meno alebo e-mail",
  "account.password": "Heslo",
  "account.passwordTips": "Zadajte heslo",
  "account.submit": "Odoslať",
  "account.submitTips": "Odosielanie prebieha, prosím počkajte...",
  "account.otherLoginTips": "Alebo vyberte iný spôsob prihlásenia",
  "account.userRegistration": "Registrácia používateľa",
  "account.userName": "Používateľské meno",
  "account.userNameTips": "Zadajte používateľské meno",
  "account.emailTips1": "Zadajte e-mailovú adresu",
  "account.emailTips2": "Neplatný formát e-mailovej adresy",
  "account.phone": "Telefónne číslo",
  "account.phoneTips1": "Zadajte telefónne číslo",
  "account.phoneTips2": "Neplatné telefónne číslo",
  "account.phoneTips3": "Zadajte telefónne číslo",
  "account.passwordTips1": "Zadajte heslo (6-30 znakov)",
  "account.passwordTips2": "Nesprávny formát hesla: heslo musí pozostávať z anglických písmen, číslic, podčiarkovníkov, pomliek a bodiek, dĺžka 6-12 znakov",
  "account.passwordTips3": "Dva zadania hesla sa nezhodujú, skontrolujte a zadajte znovu!",
  "account.passwordTips4": "Zadajte heslo: heslo musí pozostávať z anglických písmen, číslic, podčiarkovníkov, pomliek a bodiek",
  "account.passwordTips5": "Potvrdenie hesla",
  "account.passwordTips6": "Zadajte potvrdenie hesla",
  "account.passwordTips7": "Dva zadania hesla sa nezhodujú, skontrolujte a zadajte znovu!",
  "account.passwordTips8": "Zadajte potvrdenie hesla",
  "account.passwordTips9": "Gratulujeme, registrácia bola úspešná!",
  "account.passwordTips10": "Vaše používateľské meno je:",
  "account.emailIs": "E-mail je:",
  "account.goToLoginPage": "Za s sekúndami budete automaticky presmerovaný na stránku prihlásenia",
  "account.goLogin": "Prihlásiť sa",
  "account.goRegister": "Registrovať sa",
  "account.loginSuccess": "Prihlásenie úspešné",
  "account.email": "E-mail",
  "account.sologn": "Srdca vytvárame energetické riadenie špecifické pre vás",
  "account.pleaseAgree": "Prečítal som a súhlasím s",
  "userAgreement.privacyPolicy": "Zásadami ochrany osobných údajov",

  "account.code": "Overovací kód",
  "account.codeTips": "Zadajte overovací kód",
  "account.codeTips2": "Neplatný overovací kód",

    "account.inviteCodeTips": "Zadajte prosím pozývací kód",
    "account.inviteCodeHint": "Pre získanie pozývacieho kódu kontaktujte prosím inštalatéra alebo prevádzkový personál",
  "account.modifyPasswordByAccount": "Zmena hesla podľa účtu",
  "account.modifyPasswordByEmail": "Zmena hesla podľa e-mailu",
  "account.getPasswordByAccount": "Obnovenie hesla podľa účtu",
  "account.getPasswordByEmail": "Obnovenie hesla podľa e-mailu",

  "account.sendEmailTips": "Overovací kód bol odoslaný na e-mail, skontrolujte si ho",
  "account.name": "Názov účtu",
  "account.newPassword": "Nové heslo",
  "account.confirmNewPassword": "Potvrdenie nového hesla",
  "account.nameTips": "Zadajte názov účtu",
  "account.passwordModifySuccess": "Zmena hesla úspešná",
  "account.emailCode": "E-mailový overovací kód",
  "account.emailCodeTips": "Zadajte e-mailový overovací kód",
  "account.emailCodeTips2": "Neplatný e-mailový overovací kód",
  "account.emailModifySuccess": "Zmena hesla úspešná",
  "account.passworTips1": "Vaše heslo bolo úspešne resetované!",
  "account.passwordTips11": "Zadajte potvrdenie hesla",
  "account.passwordTips12": "Zadajte nové heslo",
  "account.nickname": "Přezdívka používateľa",
  "account.modifyNickname": "Zmena prezdivky používateľa",
  "account.modifyNicknameSuccess": "Zmena prezdivky používateľa úspešná!",
  "account.nicknameTips": "Zadajte prezdivku používateľa",
  "account.nicknameError": "Zmena prezdivky používateľa zlyhala!",

  "account.login": "Prihlásiť sa",
  "account.quickRegister": "Rýchla registrácia",
  "account.sendCode": "Pošlji kodo",
  "account.sendTips": "Za s sekúndami môžete odoslať znovu",
  "account.sendEmailIng": "Odosielanie e-mailu prebieha, prosím počkajte...",
  "account.emailNotEmpty": "E-mailová adresa nemôže byť prázdna",
  "account.registerAccount": "Registrovať účet",
  "account.registerWelcome": "Vitajte pri registrácii v SusprSafe",
  "account.usernameLimit": "Používateľské meno musí začínať písmenom a môže obsahovať iba písmená, čísla a podčiarkovníky, dĺžka 5-15 znakov",

  "copyright.desc2": "Informácie o záznamu webu: ICP záznam Guangdong No. 2021169764",

  "editUserInfo.editUserInformation": "Upraviť informácie o používateľovi",
  "editUserInfo.modifyUsername": "Zmeniť používateľské meno",
  "editUserInfo.changePictures": "Zmeniť profilovú fotku",
  "editUserInfo.savePicturesSuccess": "Profilová fotka používateľa uložená úspešne",
  "editUserInfo.saveError": "Uloženie zlyhalo",
  "editUserInfo.pictureLimit": "Obrázok musí byť menší ako 2 MB",
  "editUserInfo.uploadPicture": "Nahrať profilovú fotku",
  "editUserInfo.picturePreview": "Náhľad",
  
  "editUserInfo.bindPhoneNumber": "Viazanie telefónneho čísla",
  "editUserInfo.bindEmail": "Viazanie e-mailu",
  "editUserInfo.changePassword": "Zmena hesla",

  "editUserInfo.notificationSettings": "Nastavenia oznámení",
  "editUserInfo.editAccount": "Upraviť informácie o účte používateľa",
  "editUserInfo.waitBingting": "Viazanie prebieha, prosím počkajte...",
  "editUserInfo.collapse": "Zbaliť",
  "editUserInfo.modifyBinding": "Upraviť väzbu",
  
  "editUserInfo.emailAddress": "E-mailová adresa",
  "editUserInfo.tips1": "Viazanie e-mailu úspešné",
  "editUserInfo.tips2": "Uloženie zlyhalo",
  "editUserInfo.tips3": "Odosielanie e-mailového overovacího kódu prebieha, prosím počkajte...",
  "editUserInfo.tips4": "Overovací kód bol odoslaný na e-mail xxxx, skontrolujte si ho",
  "editUserInfo.tips5": "Odosielanie overovacího kódu zlyhalo!",
  "editUserInfo.tips6": "Telefónne číslo už je viazané",
  "editUserInfo.tips7": "E-mail už je viazaný",
  "editUserInfo.emailTips1": "Zadajte e-mailovú adresu",
  "editUserInfo.emailTips2": "Neplatný formát e-mailovej adresy",
  "editUserInfo.emailTips3": "Za xxxx sekúndami môžete odoslať znovu",
  "editUserInfo.emailTips4": "Pošlji kodo",
  "editUserInfo.emailTips5": "E-mailový overovací kód nemôže byť prázdny",
  "editUserInfo.emailTips6": "Neplatný e-mailový overovací kód",
  "editUserInfo.emailCode": "E-mailový overovací kód",
  "editUserInfo.save": "Uložiť",

  "editUserInfo.phoneTips1": "Viazanie telefónneho čísla úspešné",
  "editUserInfo.phoneTips2": "Odosielanie SMS overovacího kódu prebieha, prosím počkajte...",
  "editUserInfo.phoneTips3": "SMS overovací kód bol odoslaný na telefón xxxx, skontrolujte si ho",
  "editUserInfo.phoneTips4": "Odosielanie SMS overovacího kódu zlyhalo!",
  "editUserInfo.phoneTips5": "Zadajte telefónne číslo",
  "editUserInfo.phoneTips6": "Neplatný formát telefónneho čísla",
  "editUserInfo.phoneTips7": "Odoslať SMS overovací kód",
  "editUserInfo.phoneTips8": "SMS overovací kód",
  "editUserInfo.phoneTips9": "SMS overovací kód nemôže byť prázdny",
  "editUserInfo.phoneTips10": "Neplatný SMS overovací kód",
  "editUserInfo.phone": "Telefónne číslo",


  "editUserInfo.noticeTips1": "Získanie nastavení oznámení zlyhalo!",
  "editUserInfo.noticeTips2": "Nastavenia oznámení uložené úspešne!",
  "editUserInfo.noticeTips3": "Oznámenie o nízkej úrovni baterie",
  "editUserInfo.noticeTips4": "Oznámenie o dokončení nabíjania nabíjačky",
  "editUserInfo.errorNotification": "Oznámenie o chybe",
  "editUserInfo.updateNotification": "Oznámenie o aktualizácii",
  "editUserInfo.monthlyStatisticsNotification": "Oznámenie o mesačných štatistikách",
  "editUserInfo.notificationMethod": "Spôsob prijímania",

  "editUserInfo.userNameTips1": "Používateľské meno uložené úspešne",
  "editUserInfo.userNameTips2": "Uloženie používateľského mena zlyhalo",
  "editUserInfo.userNameTips3": "Zadajte používateľské meno",
  "editUserInfo.userNameTips4": "Neplatný formát používateľského mena: musí pozostávať z číslic, podčiarkovníkov a anglických písmen",
  "editUserInfo.userNameTips5": "Zadajte používateľské meno",
  "editUserInfo.userNameTips6": "Ukladanie prebieha, prosím počkajte...",
  "editUserInfo.userName": "Používateľské meno",

  "editUserInfo.avatorTips": "Kliknite na zmenu profilovej fotky",
  "editUserInfo.verifyCodeTips1": "Zadajte overovací kód, ktorý ste obdržali:",
  "editUserInfo.verifyCodeTips2": "Pre bezpečnosť vašho účtu kliknite na tlačidlo nižšie pre odoslanie overovacího kódu na pôvodné telefónne číslo:",
  "editUserInfo.verifyCodeTips3": "Pošlji kodo",
  "editUserInfo.verifyCodeTips4": "Overenie pôvodného telefónu úspešné, zadajte nové viazané telefónne číslo",
  "editUserInfo.verifyCodeTips5": "Pre bezpečnosť vašho účtu kliknite na tlačidlo nižšie pre odoslanie overovacího kódu na pôvodný e-mail:",
  "editUserInfo.verifyCodeTips6": "Overenie pôvodného e-mailu úspešné, zadajte nový e-mail",
  "editUserInfo.verifyCodeTips7": "Staré heslo",
  "editUserInfo.verifyCodeTips8": "Najskôr viažte e-mail!",
  "editUserInfo.verifyCodeTips9": "Overovací kód bol odoslaný na e-mail, skontrolujte si ho",
  "editUserInfo.verifyCodeTips10": ", budete automaticky presmerovaný na stránku prihlásenia",

  "hems.notice.title": "Názov oznámenia", 
  "hems.notice.content": "Obsah oznámenia", 
  "hems.notice.operate": "Operácia",
  "hems.notice.noRead": "Neprečítané",
  "hems.notice.read": "Prečítané",
  "hems.notice.warning": "Upozornenie",
  "hems.notice.error": "Chyba",
  "hems.notice.success": "Štatistická úhrada",
  "hems.notice.sys": "Systémová informácia",
  "hems.notice.operateSuccess": "Operácia úspešná",
  "hems.notice.operateTips": "Vyberte položku na operáciu",

  // 首页
  "hems.home.selfuseRate": "Miera samopoužitia",
  "hems.home.percent": "Procentá",
  "hems.home.todayData": "Dnešné dáta",
  "hems.home.todayPowerGeneration": "Dnešná generácia energie",
  "hems.home.salesIncome": "Příjem z predaja energie",
  "hems.home.saved": "Usporiadali ste",
  "hems.home.reduce": "Zníženie uhlíkového stopy",
  "hems.home.tips1": "Zatiaľ žiadne údaje, ešte ste neviazali xxxx",
  "hems.home.criticalLoad": "Kritická záťaž",
  "hems.home.keyVoltage": "Kritické napätie",
  "hems.home.householdLoad": "Domáca záťaž",
  "hems.home.householdVoltage": "Domáce napätie",
  "hems.home.generalLoad": "Bežná záťaž",
  "hems.home.generalVoltage": "Bežné napätie",
  "hems.home.batteryHealth": "Zdravotný stav batérie",
  "hems.home.averageTemp": "Priemerná teplota",
  "hems.home.gridLoad": "Záťaž elektrickej siete",
  "hems.home.toggeleDataSource": "Aktuálne zobrazené dáta boli prepnuté na:",
  "hems.home.toggleTips": "Ste si istý, že chcete prepnúť?",
  "hems.home.modeSending": "Odosielanie príkazu režimu prebieha, prosím počkajte...",
  "hems.home.modeSuccess": "Príkaz na prepnutie režimu bol úspešne odoslaný!",
  "hems.home.isOnline": "Je online?",
  "hems.home.useStatus": "Stav používania",
  "hems.home.workModeText": "Aktuálny pracovný režim:",
  "hems.home.toggleDataSourceText": "Aktuálne zobrazené dáta boli prepnuté na:",
  "hems.ev.charge.status": "Stav nabíjania",
  "hems.ev.charge.time": "Trvanie nabíjania",
  "hems.ev.charge.count": "Reálny počet nabitých kWh",
  "hems.ev.charge.status.empty": "Voľná",
  "hems.ev.charge.status.ing": "Nabíjanie s pripojenou súčiastkou",
  "hems.ev.charge.status.null": "Súčiastka pripojená, ale bez nabíjania",
  "hems.ev.charge.status.error": "Chyba",
  "hems.hour": "hodina",
  "hems.minue": "minúta",
  "hems.ev.chagre.number": "Číslo nabíjačky",

  // User Guide
  "hems.userGuide.selfUse": "Samopoužitie generovanej energie",
  "hems.userGuide.selfUseTips": "Prednostne používať fotovoltaickú energiu, pri nedostatku doplniť z elektrickej siete",
  "hems.userGuide.economyMode": "Hospodársky režim",
  "hems.userGuide.economyModeTips": "Optimalizácia stratégie používania energie podľa ceny elektriky",
  "hems.userGuide.emergencyMode": "Požiarný režim",
  "hems.userGuide.emergencyModeTips": "Prednostne zaručiť napájanie kritickej záťaže",

  // 图表页面
  "hems.history.energyStatistics": "Štatistiky energie",
  "hems.history.revenueStatistics": "Štatistiky príjmov",
  "hems.history.greenStatistics": "Zelené zníženie emisií",
  "hems.history.revenueTitle": "Celkový príjem z predaja energie",
  "hems.history.savingsTitle": "Celkové úspory",
  "hems.history.carbonTitle": "Celkové zníženie uhlíkových emisií",
  "hems.history.day": "deň",
  "hems.history.month": "mesiac",
  "hems.history.year": "rok",
  "hems.history.beforeDay": "Predchádzajúci deň",
  "hems.history.afterDay": "Nasledujúci deň",
  "hems.history.beforeMonth": "Predchádzajúci mesiac",
  "hems.history.afterMonth": "Nasledujúci mesiac",
  "hems.history.beforeYear": "Predchádzajúci rok",
  "hems.history.afterYear": "Nasledujúci rok",
  "hems.history.totalUse": "Celkové používanie",
  "hems.history.fullScreen": "Plný obrazovka",
  "hems.history.timeSelect": "Výber dátumu",
  "sync.tips1": "Príkaz na synchronizáciu dát bol úspešne odoslaný!",
  "sync.tips2": "Synchronizácia dát prebieha, kvôli veľkosti dát trvá to chvíľu, skontrolujte si to o pol hodiny neskôr~",
  "sync.tips3": "Synchronizácia dát zariadenia môže mať oneskorenie, ak zistíte nekonzistencie v dátach, kliknite na:",
  "sync.tips4": "Synchronizovať dáta",

  "charge.info": "Informácie o nabíjačke",
  "news.loading": "Načítanie prebieha...",
  "news.noMore": "Žiadne ďalšie položky",
  "hems.pv.power": "Množstvo energie z fotovoltaiky",

  // UEH specific
  "ueh.sellPower": "Množstvo predanej energie",
  
  "menu.home": "Domovská stránka",
  "menu.history": "Historické dáta",
  "menu.device": "Zariadenia",
  "menu.settings": "Nastavenia",
  "menu.messageCenter": "Centrum správ",
  "menu.help": "Pomoc a podpora",
  "menu.mine": "Moje",


  "mine.userSetting": "Nastavenia používateľa",
  "mine.terminalSetting": "Základné nastavenia terminálu",
  "mine.uploadCloud": "Zálohovanie dát do cloudu",
  "mine.changeVersion": "Skontrolovať aktualizácie",
  "mine.language": "Prepnúť jazyk",
  "mine.about": "O aplikácii",
  "mine.feedback": "Spätná väzba",
  "mine.logout": "Odhlásiť sa",
  "mine.logoutAccount": "Zrušiť účet",

  "mine.logoutAccountTips": "Zrušiť účet s názvom []",
  "mine.logoutAccountTips1": "Zrušiť účet viazaný na []",
  "mine.logoutAccountCare": "Pokiaľ žiadate zrušenie účtu, prosím berte na vedomie nasledujúce body:",
  "mine.logoutAccountCare1": "1. Účet je v bezpečnom stave",
  "mine.logoutAccountCare1-1": "Účet je v normálnom stave používania, bez rizika krádeže, porušenia pravidiel alebo blokovania.",
  "mine.logoutAccountCare2": "2. Autorizácie a väzby účtu boli odstránené",
  "mine.logoutAccountCare2-1": "Všetky autorizácie účtu s inými tretími platformami boli odstránené.",
  "mine.logoutAccountCare3": "3. Po zrušení účtu sa nemôže obnoviť, údaje používateľa budú vymazané",
  "mine.logoutAccountCare3-1": "Po zrušení účtu budú viazané telefónne číslo, e-mail a ďalšie súvisiace údaje vymazané a nemôžu sa obnoviť.",
  "mine.confirmLogout": "Potvrdiť zrušenie",
  "mine.logoutSuccess": "Účet bol úspešne zrušený!",


  "mine.feedbackIssues": "Spätná väzba k problémom",
  "mine.feedQuantity": "Počet",
  "mine.feedAmount": "Maximálne 9 obrázkov, maximálna veľkosť 1 MB/obrázok",

  "mine.notice.fail": "Získanie nastavení oznámení zlyhalo!",
  "mine.notice.saveSuccess": "Nastavenia oznámení uložené úspešne!",
  "mine.notice.saveFail": "Uloženie zlyhalo!",
  "mine.notice.title": "Nastavenia oznámení",
  "mine.notice.batteryLow": "Oznámenie o nízkej úrovni baterie",
  "mine.notice.chargingFinish": "Oznámenie o dokončení nabíjania nabíjačky",
  "mine.notice.error": "Oznámenie o chybe",
  "mine.notice.update": "Oznámenie o aktualizácii",
  "mine.notice.monthly": "Oznámenie o mesačných štatistikách",
  "mine.notice.receiveType": "Spôsob prijímania",

  "mine.language.welcome": "Vitajte v SusprSafe",
  "mine.language.desc1": "Nastavte jazykovú verziu podľa vašej lokality",
  "mine.language.desc2": "Zmeny môžete vykonať kedykoľvek v nastaveniach aplikácie",

  "mine.userInfo.avatar": "Profilová fotka",
  "mine.userInfo.nickname": "Přezdívka",
  "mine.userInfo.password": "Heslo",
  "mine.userInfo.changePassword": "Zmeniť heslo",
  "mine.userInfo.setPassword": "Nastaviť heslo",
  "mine.userInfo.phoneNumber": "Telefónne číslo",
  "mine.userInfo.bindPhone": "Viazanie telefónneho čísla",
  "mine.userInfo.bindEmail": "Viazanie e-mailu",
  "mine.loginExpired": "Stav prihlásenia vypršal, prihláste sa znovu",
  "mine.userInfo.title": "Informácie o používateľovi",
  "mine.userInfo.bind": "Viazanie",
  "mine.userInfo.modify": "Upraviť",
  "mine.userInfo.modifyNickname": "Zmeniť prezdivku",
  "mine.userInfo.userNickname": "Přezdívka používateľa",
  "mine.userInfo.selectPic": "Vyberte obrázok na nahratie",
  "mine.userInfo.saveSuccess": "Uloženie úspešné",
  "mine.userInfo.uploadFail": "Nahratie zlyhalo",
  "mine.userInfo.avatarSaveSuccess": "Profilová fotka uložená úspešne",
  "mine.userInfo.nameTips1": "Přezdívka používateľa nemôže byť prázdna",
  "mine.userInfo.nameTips2": "Zadajte prezdivku používateľa",

  "common.pleaseSelect": "Prosím vybrať",
  "question.commonQuestions": "Časté otázky",
  "account.toggleLanguage": "Prepnúť jazyk",
  "account.localConnection": "Miestne pripojenie",
  "account.selectLanguage": "Prosím vybrať jazyk",
  "account.sendEmailToast": "Overovací kód bol odoslaný na e-mail xxx, skontrolujte si ho",
  "account.emailError": "Neplatný formát e-mailu",
  "account.sendEmailFail": "Odosielanie zlyhalo, skúste znovu",
  
  "common.submitting": "Odosielanie prebieha, prosím počkajte...",

  "device.page.noData": "Zatiaľ žiadne údaje, túto stránku môžete prezrieť len v aplikácii"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};